"use client";

import { ChevronRight } from "lucide-react";
import * as React from "react";

import { cn } from "@/lib/utils";

const BreadCrumb = ({ className, ...props }: React.ComponentProps<"nav">) => (
	<nav className={cn("lg:flex", className)} aria-label="Breadcrumb" {...props}>
		<ol
			role="list"
			className="flex flex-wrap items-center gap-x-1 text-13 -tracking-2 md:text-base [&>li:last-child>svg]:hidden"
		>
			{props.children}
		</ol>
	</nav>
);
BreadCrumb.displayName = "BreadCrumb";

const BreadCrumbItem = ({ className, ...props }: React.ComponentProps<"a">) => (
	<li className="flex items-center">
		<a
			className={cn(
				"flex items-center py-0.5 leading-5 text-examine-purple-200 hover:text-examine-purple-100 md:py-1",
				className
			)}
			{...props}
		>
			{props.children}
		</a>
		<ChevronRight className="ml-1 size-4 text-gray-400" />
	</li>
);
BreadCrumbItem.displayName = "BreadCrumbItem";

export { BreadCrumb, BreadCrumbItem };
